import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationSK from './locales/sk/translation.json';
import translationCZ from './locales/cz/translation.json';
import cookiesEN from './locales/en/cookies.json';
import cookiesSK from './locales/sk/cookies.json';
import cookiesCZ from './locales/cz/cookies.json';

const resources = {
  en: {
    translation: translationEN,
    cookies: cookiesEN,
  },
  sk: {
    translation: translationSK,
    cookies: cookiesSK,
  },
  cz: {
    translation: translationCZ,
    cookies: cookiesCZ,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
